module.exports = __webpack_public_path__ + "media/images/thumbnails/thumb3-50ef345a7b7516749b718da7b96e5cd2.jpg";